import { css } from 'emotion';

export const refresh = css`
	cursor: pointer;
	float: right;
`;

export const viewLbl = css`
	border: none !important;
`;

export const viewSelectorRow = css`
	padding: 10px 0 20px 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const tabsWrapper = css`
	display: flex;
	justify-content: space-between;
	padding-bottom: 20px;
`;

export const buttonsRow = css`
	padding-bottom: 20px;
`;

export const footer = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-left: 10px;
`;

export const formGroup = css`
	flex-wrap: wrap;
	> div.field {
		padding-top: 0.5em;
		padding-bottom: 0.5em;
	}
	padding-top: 20px;
`;

export const filesToUploadBox = css`
	padding-bottom: 20px;
`;
export const radioGroup = css`
	padding-top: 7px;
`;

export const dbtn = css`
	margin-left: 2px !important;
`;

export const hand = css`
	cursor: pointer;
`;

export const code = css`
	cursor: pointer;
	font-weight: bold;
`;

export const approvalCont = css`
	margin-top: 40px !important;
	margin-bottom: 40px !important;
`;

export const questionsCont = css`
	margin-top: 60px !important;
`;

export const modalApprovalCont = css`
	min-height: 400px !important;
`;

export const header = css`
	color: #ffffff !important;
	background-color: #0d71bb !important;
	padding: 0.6em 0.78571429em !important;
`;

export const headerRow = css`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const ph = css`
	color: white;
`;

export const modalConfirmation = css`
	margin-top: auto !important;
	display: inline-block !important;
	position: relative;
	top: 35%;
`;

export const buttonsRowSpaced = css`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const buttonCont = css`
	display: flex;
	flex-direction: row;
`;

export const uploadInfoCont = css`
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	align-items: center;
	margin-top: 10px;
	padding-left: 10px;
	padding-right: 0px;
	margin-right: 0.25em;
`;

export const rd = css`
	border-bottom-width: 0px !important;
`;
export const cd = css`
	padding: 0em !important;
`;

export const toggleMargin = css`
	margin-bottom: 35px !important;
	margin-top: 25px !important;
	margin-left: 8px !important;
`;

export const labelWrap = css`
	margin-bottom: 0.286rem !important;
	margin-top: 0px !important;
	margin-left: 0px !important;
	font-size: 0.92em !important;
	font-weight: bold;
`;

export const marginRightDD = css`
	margin-right: 20px !important;
`;



// WEBPACK FOOTER //
// ./src/components/Reminder/styles.js